import React from "react";

const ToolBar = ({ children }) => {
  return <div className="w-full justify-between">{children}</div>;
};

export default ToolBar;
